import ObserverFactory from './Observer';

const logoutObserver = new ObserverFactory<null>();
export default logoutObserver;
